import type { HttpGet } from '@/shared/infra/http'
import { buildQueryString, mapServerError } from '@/shared/infra/http'
import { AgeRestrictedError, ConnectAccessDeniedError, EulaRequiredError } from '@/shared/domain'
import type { LoadConnectUnreadTotal } from '@/shared/domain/use-cases'

type ConnectUnreadCountResponse = { total?: number | null }

export class EdgeLoadConnectUnreadTotalRepository {
  constructor(private readonly http: HttpGet) {}

  execute: LoadConnectUnreadTotal = async ({ orgId, orgType }) => {
    try {
      const data = await this.http.get<ConnectUnreadCountResponse>({
        url: `/connect/channels/unread-count${buildQueryString({ orgId, orgType })}`,
      })
      return { total: data?.total ?? 0 }
    } catch (err) {
      mapServerError(err, {
        '403': ConnectAccessDeniedError,
        '428': EulaRequiredError,
        '451': AgeRestrictedError,
      })
    }
  }
}
